const styles = (theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridAutoRows: 'minmax(160px, auto)',
    gap: '1rem',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
    },
  },
})

export default styles
